<!--
 * @Author: your name
 * @Date: 2022-03-21 10:56:01
 * @LastEditTime: 2022-03-22 17:29:21
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \ant-design-vue-jeecg\src\views\system\modules\UserAppModal.vue
-->
<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    width="650"
    placement="right"
    :closable="true"
    @close="close"
    :visible="visible"
    :destroyOnClose="true"
    style="overflow: auto; padding-bottom: 53px"
  >
    <a-form>
      <a-form-item label="允许访问的app">
        <a-checkbox-group v-model="value" :defaultValue="defaultCheckedKeys" name="checkboxgroup" :options="data" />
      </a-form-item>
    </a-form>

    <div class="drawer-bootom-button">
      <a-popconfirm title="确定放弃编辑？" @confirm="close" okText="确定" cancelText="取消">
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit(false)" type="primary" :loading="loading" ghost style="margin-right: 0.8rem"
        >仅保存</a-button
      >
      <a-button @click="handleSubmit(true)" type="primary" :loading="loading">保存并关闭</a-button>
    </div>
  </a-drawer>
</template>
<script>
import { getAppsList, saveTenantApps, getTenantApps } from '@/api/api'

export default {
  name: 'TenantAppModal',
  components: {},
  data() {
    return {
      title: '租户App授权配置',
      visible: false,
      loading: false,
      tenantId: '',
      data: [],
      value: [],
      defaultCheckedKeys: [],
    }
  },
  methods: {
    loadData() {
      getAppsList({ appType: this.appType }).then((res) => {
        console.log(res)
        this.data = res.result.records.map((r) => ({
          label: r.name,
          value: r.id,
        }))

        getTenantApps({ tenantId: this.tenantId }).then((res) => {
          const checked = res.result.map((r) => r.appId)
          this.value = [...checked]
          this.defaultCheckedKeys = [...checked]
        })
      })
    },
    handleSubmit(exit) {
      let that = this
      let params = {
        tenantId: that.tenantId,
        permissionIds: that.value.join(','),
        lastpermissionIds: that.defaultCheckedKeys.join(','),
      }
      that.loading = true
      console.log('请求参数：', params)
      saveTenantApps(params).then((res) => {
        if (res.success) {
          that.$message.success(res.message)
          that.loading = false
          if (exit) {
            that.close()
          }
        } else {
          that.$message.error(res.message)
          that.loading = false
          if (exit) {
            that.close()
          }
        }
        this.loadData()
      })
    },
    show(tenantId, appType) {
      this.tenantId = tenantId
      this.appType = appType
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        this.loadData()
      }
    },
  },
}
</script>
<style lang="less" scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>